module.exports = __webpack_public_path__ + "img/success-alert.f97504ab.svg";